export const contactDetails = {
  phone: "+44 (0) 1491 833 732",
  phoneHref: "+441491833732",
  email: "info@waterfrontcafe.co.uk",
  address: "A4074 Benson Waterfront, Wallingford, Oxfordshire, OX10 6SJ",
  what3words: "elders.genius.magnitude",
};

export const hours = [
  { label: "Open Daily", value: "08:30 AM to 19:00 PM" },
  { label: "Breakfast", value: "Served until 11:30 AM" },
  { label: "Main Menu", value: "Served from 11:30 AM" },
  { label: "Booking", value: "Walk-ins welcome" },
];

export const breakfastItems = [
  { title: "Upper Deck Breakfast", desc: "Two bacon, two sausages, fried egg, beans, toast and grilled tomato.", price: "12.95" },
  { title: "Vegetarian Breakfast", desc: "Egg, hash browns, beans, tomato, mushroom and toast.", price: "11.95", tag: "Vegetarian" },
  { title: "Vegan Breakfast", desc: "Vegan sausages, hash browns, avocado, mushroom, tomato and toast.", price: "11.95", tag: "Vegan" },
  { title: "Eggs Benedict", desc: "Ham, hollandaise and toasted English muffin.", price: "10.95" },
  { title: "Egg Royale", desc: "Smoked salmon, hollandaise and toasted English muffin.", price: "11.95" },
  { title: "American Pancakes", desc: "Crispy bacon and maple syrup, or yoghurt with berries.", price: "9.95" },
  { title: "Greek Yoghurt", desc: "Banana and honey, or granola and berries.", price: "6.95" },
  { title: "Rustic Breakfast Roll", desc: "Bacon, sausage, egg, or a hearty combination.", price: "6.95" },
];

export const mainItems = [
  { title: "Homemade Beer Battered Cod", desc: "Chips, mushy peas and tartare sauce.", price: "16.95" },
  { title: "Waterfront Chargrilled Chicken", desc: "Coleslaw, chips, garnish and honey mustard.", price: "15.95" },
  { title: "Sirloin Steak 10oz", desc: "Mushroom, tomato, chips, salad and peppercorn sauce.", price: "24.95" },
  { title: "Plant-Based Burger", desc: "Soft brioche style bun, chips and house garnish.", price: "14.95", tag: "Vegetarian" },
  { title: "Warm Goat Cheese Salad", desc: "Beetroot, walnut, cucumber, tomato and mixed leaves.", price: "13.95", tag: "Vegetarian" },
  { title: "Pasta Arrabbiata", desc: "Tomato, garlic and chilli with your choice of pasta.", price: "12.95", tag: "Vegetarian" },
  { title: "Waterfront Nachos", desc: "Salsa, jalapeno, melted cheese, sour cream and guacamole.", price: "12.95" },
  { title: "Ben & Jerry's Counter", desc: "Cup or cone flavours served from the ice cream counter.", price: "4.95" },
];

export const drinkItems = [
  { title: "Prosecco", desc: "Lively Italian fizz, fruity and refreshing.", price: "7.50" },
  { title: "Champagne Gremillet", desc: "Crisp, elegant and balanced with a creamy finish.", price: "11.50" },
  { title: "Sauvignon Blanc", desc: "Dry, vibrant and citrus led.", price: "7.25" },
  { title: "House Red", desc: "Light, flavoursome French table wine.", price: "6.75" },
  { title: "Draught Beer", desc: "San Miguel, 1664, Wainwright and rotating taps.", price: "5.95" },
  { title: "Cocktails", desc: "Mojito, martini, Woo Woo and summer favourites.", price: "9.50" },
  { title: "Speciality Tea", desc: "Green, peppermint, chai, darjeeling and more.", price: "3.25" },
  { title: "Barista Coffee", desc: "Latte, cappuccino, americano, espresso and flat white.", price: "3.60" },
];

export const galleryImages = [
  "https://static.wixstatic.com/media/470683_7ca1559c234c439893aad09334695d85~mv2.jpg",
  "https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1559925393-8be0ec4767c8?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1564759224907-65b945ff0e84?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1481833761820-0509d3217039?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1521017432531-fbd92d768814?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=900&q=80",
];

export const events = [
  { title: "Riverside Supper Evening", date: "Friday evenings", desc: "Seasonal specials, wine and golden-hour views from the deck." },
  { title: "Weekend Breakfast Club", date: "Saturday and Sunday", desc: "Slow mornings, fresh pastries and generous breakfast plates." },
  { title: "Private Celebrations", date: "On request", desc: "Relaxed waterside gatherings for birthdays, family meals and small parties." },
];

export const testimonials = [
  { name: "Sophie M.", quote: "Beautiful setting, relaxed service and the best coffee stop after a river walk.", rating: 5 },
  { name: "Daniel R.", quote: "The deck is a gem. Breakfast was generous and the staff were lovely.", rating: 5 },
  { name: "Amelia P.", quote: "A calm, friendly place with proper food and a view you want to linger over.", rating: 5 },
];
